export const SIMULATOR_PRESENTATION_PAGE = '/';
export const SIMULATOR_STEPS_PAGE = '/stepper';
export const SAVE_SIMULATION_PAGE = '/results/save';
export const SIMULATOR_CONFIRMATION_PAGE = '/confirmation/:code';
export const SIMULATOR_RESULTS_PAGE = '/results/:code?';
export const EMPLOYEE_SIMULATOR_PAGE = '/employee/:token/*';
